import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useLogoutStyles() {
  const { fonts, spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      icon: {
        fontSize: fonts.medium.fontSize,
        fontWeight: `bolder`,
        marginRight: spacing.s1
      },
      user: {
        fontSize: fonts.large.fontSize
      }
    }),
    [fonts, spacing]
  );
}
